export default __webpack_public_path__ + "static/media/whatsapp-banner.2935180d.jpg";